import React, {Component} from 'react';
import PropTypes from 'prop-types';
import CalendarControl from '../PageLayout/CalendarControl';

export class ESignatureComponent extends Component {
  static propTypes = {
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    contactName: PropTypes.string,
    email: PropTypes.string.isRequired,
    businessName: PropTypes.string,
    programType: PropTypes.string.isRequired,
    paymentType: PropTypes.string.isRequired,
    paymentAmount: PropTypes.number,
    businessPhone: PropTypes.string,
    businessWebSite: PropTypes.string,
    formSubmittedFn: PropTypes.func,
    last4CC: PropTypes.string,
    curDate: PropTypes.string
  }

  constructor(ownProps) {
    super(ownProps);

    this.state = {}
  }

  componentDidMount() {
    this.setupJotForm();
  }

  setupJotForm = () => {
    const ifr = document.getElementById("JotFormIFrame-" + this.getJotFormId());
    if (window.location.href && window.location.href.indexOf("?") > -1
    ) {
      const get = window.location.href.substr(window.location.href.indexOf("?") + 1);
      if (ifr && get.length > 0) {
        let src = ifr.src;
        src = src.indexOf("?") > -1 ? src + "&" + get : src + "?" + get;
        ifr.src = src;
      }
    }
    window.handleIFrameMessage = (e) => {
      if (typeof e.data === 'object') {
        // https://www.jotform.com/answers/1609027-Iframe-embedded-form-does-iframe-emit-events
        // hopefully the event name won't change
        if (e.data.action === 'submission-completed') {
          if (this.props.formSubmittedFn)
            this.props.formSubmittedFn();
        }
        return;
      }
      const args = e.data.split(":");
      let iframe;
      if (args.length > 2) {
        iframe = document.getElementById("JotFormIFrame-" + args[(args.length - 1)]);
      } else {
        iframe = document.getElementById("JotFormIFrame");
      }
      if (!iframe) {
        return;
      }
      switch (args[0]) {
        case "scrollIntoView":
          iframe.scrollIntoView();
          break;
        case "setHeight":
          //iframe.style.height = args[1] + "px";
          break;
        case "collapseErrorPage":
          if (iframe.clientHeight > window.innerHeight) {
            iframe.style.height = window.innerHeight + "px";
          }
          break;
        case "reloadPage":
          window.location.reload();
          break;
        case "loadScript":
          let src = args[1];
          if (args.length > 3) {
            src = args[1] + ':' + args[2];
          }
          let script = document.createElement('script');
          script.src = src;
          script.type = 'text/javascript';
          document.body.appendChild(script);
          break;
        case "exitFullscreen":
          if (window.document.exitFullscreen) window.document.exitFullscreen();
          else if (window.document.mozCancelFullScreen) window.document.mozCancelFullScreen();
          else if (window.document.mozCancelFullscreen) window.document.mozCancelFullScreen();
          else if (window.document.webkitExitFullscreen) window.document.webkitExitFullscreen();
          else if (window.document.msExitFullscreen) window.document.msExitFullscreen();
          break;
      }
      const isJotForm = (e.origin.indexOf("jotform") > -1);
      if (isJotForm && "contentWindow" in iframe && "postMessage" in iframe.contentWindow) {
        const urls = {"docurl": encodeURIComponent(document.URL), "referrer": encodeURIComponent(document.referrer)};
        iframe.contentWindow.postMessage(JSON.stringify({"type": "urls", "value": urls}), "*");
      }
    };
    if (window.addEventListener) {
      window.addEventListener("message", handleIFrameMessage, false);
    } else if (window.attachEvent) {
      window.attachEvent("onmessage", handleIFrameMessage);
    }
  }

  createUrlForFields = () => {
    return 'businessName=' + this.props.businessName +
      '&firstName=' + this.props.firstName +
      '&lastName=' + this.props.lastName +
      '&email=' + this.props.email +
      '&contactName=' + this.props.contactName +
      '&businessPhone17=' + this.props.businessPhone +
      '&businessWebsite=' + this.props.businessWebSite +
      '&paymentAmount=' + this.props.paymentAmount +
      '&lastFour=' + this.props.last4CC;
  }

  static jotFormIDs = {
    'free': {
      'trial': '90148540200141'
    },
    'pay-per-lead': {
      'lead': '90159068346159'
    },
    'basics': {
      'monthly': '90158768240158',
      'annually': '90158671095159'
    },
    'enterprise': {
      'monthly': '90158592542158',
      'annually': '90158376339162'
    },
    'kv-only': {
      'monthly': '91516655594164',
      'annually': '91555783708166'
    },
    'bv-only': {
      'monthly': '91516455135153',
      'annually': '91555308476161'
    },
    'kv-bv-only': {
      'monthly': '91516269960162',
      'annually': '91556154172154'
    },
    'finger-signature': {
      'default': '90148540200141' // TODO: use real Jot form Id
    }
  }

  getJotFormId = () => {
    // 90148540200141 - Free Software Contract
    // 90159068346159 - Leads Program Contract
    // 90158768240158 - Basics Program Monthly Contract
    // 90158671095159 - Basics Annual Software Agreement
    // 90158592542158 - Enterprise Monthly Agreement
    // 90158376339162 - Enterprise Annual Agreement
    const pid = ESignatureComponent.jotFormIDs[this.props.programType];
    if (pid) {
      const id = pid[this.props.paymentType];
      if (id)
        return id;
    }

    alert('ERR: Wrong combination of programType ' + this.props.programType + ' and payType ' + this.props.paymentType);
    return null;
  }

  render() {
    const jotFormId = this.getJotFormId();
    return (
      <div>

        <iframe
          id={"JotFormIFrame-" + jotFormId}
          onLoad={window.parent.scrollTo(0,0)}
          allowFullScreen={true}
          style={{backgroundColor:'transparent',
            height: 'calc(100vh - 200px)',
            width: '100%',
            position: 'fixed',
            zIndex: 100,
            top: '120px',
            left: 0
        }}
          allow=""
          // allow="geolocation; microphone; camera"
          src={`https://form.jotform.com/${jotFormId}?${this.createUrlForFields()}`}
          frameBorder="0"
          scrolling="yes"
        >
        </iframe>
      </div>
    )
  }
}
/*
const iFrameStyle = {
  width: '1px',
  minWidth: '100%',
  height: 'calc(100vh - 200px)',
  border: 'none',
  margin: '100px 0 80px 0'
};*/
